import React, { useEffect, useState } from 'react';
import PortalDownloads from './components/PortalDownloads';
import type { ZipDownloadResponse } from '../../types/downloads';

interface DownloadsBlockProps {
  heading?: string;
  expiryNotificationText?: string;
  expiryDateLabel?: string;
}

export default function DownloadsBlock({
  heading,
  expiryNotificationText,
  expiryDateLabel,
}: Readonly<DownloadsBlockProps>) {
  const [downloads, setDownloads] = useState<ZipDownloadResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDownloads = async () => {
      try {
        const response = await fetch('/api/downloads/get-bulk-downloads');
        if (response.ok) {
          const data = await response.json();
          setDownloads(data);
        }
      } catch (error) {
        console.error('Error fetching downloads:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDownloads();
  }, []);

  // Don't show skeleton - this component is conditionally rendered and the API is fast,
  // so a skeleton flash followed by disappearance is worse UX than showing nothing
  if (isLoading || !downloads?.items?.length) {
    return null;
  }

  return (
    <PortalDownloads
      downloads={downloads.items}
      heading={heading}
      expiryNotificationText={expiryNotificationText}
      expiryDateLabel={expiryDateLabel}
    />
  );
}
